module.exports = __webpack_public_path__ + "static/media/CV_LuisBoscan_EN.d0992343.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/docs/CV_LuisBoscan_EN.pdf
// module id = 759
// module chunks = 0